import { useSyncExternalStore } from "react";

import type { SessionDto } from "@mandoob/shared";

import { getSession as fetchSession } from "@/api/session";

// The signed-in driver's context, loaded once at boot from GET /api/session.
// Module store + useSyncExternalStore (same pattern as the language context).

let session: SessionDto | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getSession(): SessionDto | null {
  return session;
}

export function setSession(next: SessionDto | null) {
  session = next;
  emit();
}

export function clearSession() {
  setSession(null);
}

export function useSession(): SessionDto | null {
  return useSyncExternalStore(subscribe, getSession, getSession);
}

export async function loadSession(): Promise<SessionDto> {
  const dto = await fetchSession();
  setSession(dto);
  return dto;
}
